import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Container, Row, Button, Table, Spinner } from "reactstrap";
import { getMyRequests } from "../../store/actions/FanActions";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const MyRequests = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { uid } = useSelector((state) => state.authUser);
    const { fanRequests, fanLoading } = useSelector(
        (state) => state.fanReducer
    );
    const [Requests, setRequests] = useState([]);

    useEffect(() => {
        dispatch(getMyRequests(uid));
    }, []);
    useEffect(() => {
        if (fanRequests?.length > 0) {
            setRequests(fanRequests);
        }
    }, [fanRequests]);

    return (
        <Container fluid>
            <Row className="justify-content-center mx-4 py-3">
                <h3>My Requests</h3>
            </Row>
            {fanLoading ? (
                <Row className="justify-content-center">
                    <Spinner size="sm" />
                </Row>
            ) : (
                <Container>
                    <Row className="justify-content-end my-3 mx-1">
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => history.push("/main/request")}
                        >
                            Make a request
                        </Button>
                    </Row>
                    <Table hover bordered responsive>
                        <thead>
                            <tr>
                                <th className="text-capitalize">request ID</th>
                                <th className="text-capitalize">
                                    athlete Name
                                </th>
                                <th className="text-capitalize">description</th>
                                <th className="text-capitalize">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Requests.length > 0 ? (
                                Requests?.map((item) => {
                                    return (
                                        <tr key={item.id} color="blue">
                                            <td>{item.id}</td>
                                            <td>{item.athlete_name}</td>
                                            <td>{item?.description}</td>
                                            <td className="text-capitalize">
                                                {item.status}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr color="blue">
                                    <td>N/A</td>
                                    <td>N/A</td>
                                    <td>N/A</td>
                                    <td>N/A</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Container>
            )}
        </Container>
    );
};

export default MyRequests;
